export const INBOX_TREATMENT_LIST_QUEUES = 'INBOX_TREATMENT_LIST_QUEUES';
export const INBOX_TREATMENT_LIST_QUEUES_SUCCESS = 'INBOX_TREATMENT_LIST_QUEUES_SUCCESS';
export const INBOX_TREATMENT_LIST_QUEUES_FAIL = 'INBOX_TREATMENT_LIST_QUEUES_FAIL';

export const INBOX_TREATMENT_LIST_QUEUES_CLEAR = 'INBOX_TREATMENT_LIST_QUEUES_CLEAR';
